/**
 * @fileoverview プレビュー画面であることを知らせる告知帯
 * @description TemplateSolutionFormLp が inject(IS_PREVIEW) を見て main の先頭に描画する。
 *              ページコンポーネント側から直接使うことは想定していない
 */
<script lang="ts">
import { defineComponent } from 'vue'
import MessageSection from '@/components/message/MessageSection.vue'

export default defineComponent({
  name: 'PreviewNotice',

  components: {
    MessageSection,
  },
})
</script>

<template>
  <MessageSection>
    <template #header>
      <p class="p u-text__small u-text__bold u-text__center">
        プレビュー表示
      </p>
    </template>
    <template #description>
      <p class="p u-text__small u-text__center">
        この画面は公開されていません
      </p>
    </template>
  </MessageSection>
</template>
